import { PageLink } from '../../../../../../../assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Estudantes',
    path: '/commercial/students',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
